import { useState, useEffect } from 'react';

/**
 * Hook to detect if the current device/environment is touch-like
 * (no hover capability, coarse pointer, or small screen).
 * Used for responsive UI adjustments without changing layout.
 */
export function useTouchLikeInteraction() {
  const [isTouchLike, setIsTouchLike] = useState(false);

  useEffect(() => {
    const mediaQuery = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(hover: none), (pointer: coarse), (max-width: 768px)') : null;

    if (!mediaQuery) return;

    const listener = (e) => setIsTouchLike(e.matches);

    // Set initial state
    setIsTouchLike(mediaQuery.matches);

    // Watch for changes
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', listener);
    } else {
      // Fallback for older browsers
      mediaQuery.addListener(listener);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', listener);
      } else {
        mediaQuery.removeListener(listener);
      }
    };
  }, []);

  return isTouchLike;
}
